import { useMutation } from '@tanstack/react-query'
import { api } from '@api'
import type { UnipileService } from '../../queries/useUnipileAccounts'

interface UnipileConnectResponse {
  url: string
}

const requestWizardUrl = async (
  service?: UnipileService,
): Promise<UnipileConnectResponse> => {
  const { data } = await api.post<UnipileConnectResponse>(
    '/ft_unipile/connect',
    service ? { service } : {},
  )
  return data
}

export const useUnipileConnect = () =>
  useMutation<UnipileConnectResponse, Error, UnipileService | undefined>({
    mutationFn: requestWizardUrl,
  })
